import { createClient } from "@supabase/supabase-js";

const SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL || "";
const SUPABASE_ANON_KEY = process.env.REACT_APP_SUPABASE_ANON_KEY || "";

function buildStubClient() {
    // Stub returned when env vars are not yet configured (deployment-in-progress state).
    // Public pages still work; admin login will show a clear error.
    const error = new Error(
        "Supabase n'est pas encore configuré. Renseignez REACT_APP_SUPABASE_URL et REACT_APP_SUPABASE_ANON_KEY dans frontend/.env."
    );
    return {
        auth: {
            async getSession() { return { data: { session: null }, error: null }; },
            async getUser() { return { data: { user: null }, error: null }; },
            async signInWithPassword() { return { data: null, error }; },
            async signOut() { return { error: null }; },
            onAuthStateChange() {
                return { data: { subscription: { unsubscribe() {} } } };
            },
        },
    };
}

export const supabase =
    SUPABASE_URL && SUPABASE_ANON_KEY
        ? createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
              auth: {
                  persistSession: true,
                  autoRefreshToken: true,
                  detectSessionInUrl: false,
              },
          })
        : buildStubClient();

export const SUPABASE_CONFIGURED = Boolean(SUPABASE_URL && SUPABASE_ANON_KEY);
